import React from 'react';
import { Box, Stack, alpha } from '@mui/material';

import { ToolboxBodyProps } from '../types';
import { getAvatarIconTestId, getAvatarTestId, toolboxIcons } from '../utils';
import { Typography } from '../../Typography';

export const Body: React.FC<ToolboxBodyProps> = ({ type, title, description }) => {
  const Icon = toolboxIcons[type];

  return (
    <Stack direction='row' spacing={2}>
      <Box
        width={48}
        height={48}
        display='flex'
        borderRadius='50%'
        flexShrink={0}
        data-testid={getAvatarTestId(type)}
        sx={({ palette }) => ({ bgcolor: alpha(palette.primary.main, 0.2) })}
      >
        <Icon
          data-testid={getAvatarIconTestId(type)}
          sx={{ color: 'primary.main', margin: 'auto' }}
        />
      </Box>
      <Box flexGrow={1}>
        <Typography gutterBottom variant='subtitle1'>
          {title}
        </Typography>
        <Typography variant='body2'>{description}</Typography>
      </Box>
    </Stack>
  );
};
